import {
  pgTable,
  text,
  timestamp,
  uuid,
  integer,
  jsonb,
  index,
  unique,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// notification_deliveries — tracks every notification sent per tenant
// ---------------------------------------------------------------------------

export const notificationDeliveries = pgTable(
  "notification_deliveries",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    personId: uuid("person_id").notNull(),
    correlationId: text("correlation_id").notNull(),
    channel: text("channel").notNull(),
    category: text("category").notNull(),
    status: text("status").notNull().default("queued"),
    provider: text("provider"),
    providerMessageId: text("provider_message_id"),
    templateId: text("template_id"),
    templateVersion: integer("template_version"),
    subject: text("subject"),
    errorMessage: text("error_message"),
    errorCode: text("error_code"),
    attempts: integer("attempts").notNull().default(0),
    metadata: jsonb("metadata").notNull().default(sql`'{}'::jsonb`),
    queuedAt: timestamp("queued_at", tz).notNull().defaultNow(),
    sentAt: timestamp("sent_at", tz),
    deliveredAt: timestamp("delivered_at", tz),
    failedAt: timestamp("failed_at", tz),
    readAt: timestamp("read_at", tz),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (t) => [
    unique("uq_delivery_tenant_correlation").on(t.tenantId, t.correlationId),
    index("idx_delivery_tenant_person").on(t.tenantId, t.personId),
    index("idx_delivery_tenant_status").on(t.tenantId, t.status),
    index("idx_delivery_tenant_channel").on(t.tenantId, t.channel),
  ],
);

// ---------------------------------------------------------------------------
// notification_dead_letters — failed deliveries moved here (council E2)
// ---------------------------------------------------------------------------

export const notificationDeadLetters = pgTable(
  "notification_dead_letters",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    deliveryId: uuid("delivery_id").notNull(),
    correlationId: text("correlation_id").notNull(),
    channel: text("channel").notNull(),
    lastError: text("last_error").notNull(),
    lastErrorCode: text("last_error_code"),
    attempts: integer("attempts").notNull(),
    originalPayload: jsonb("original_payload").notNull(),
    resolvedAt: timestamp("resolved_at", tz),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (t) => [
    index("idx_dead_letter_tenant").on(t.tenantId),
    index("idx_dead_letter_delivery_id").on(t.deliveryId),
    index("idx_dead_letter_correlation").on(t.correlationId),
  ],
);
